const styleSheet = {
  container: {
    maxWidth: "320px",
    margin: "0 auto"
  },
  controls: {
    marginTop: "48px",
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginRight: "32px"
    },
    "& :last-child": {
      marginRight: 0
    }
  },
  alerts: {
    marginTop: "30px"
  },
  alertOptions: {
    animation: "0.5s fadeIn",
    marginTop: "15px",
    paddingLeft: "27px"
  },
  checkBoxRow: {
    margin: "15px 0",
    display: "flex",
    "& span": {
      paddingLeft: "10px",
      color: "#085FE5",
      fontSize: "12px"
    }
  },
  "@keyframes fadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  }
};

export default styleSheet;
